<template>
  <div>
    <div class="page_title flex_between">
      <span>
        <span>病历摘要</span>
        <span
          v-if="status == 1"
          class="status"
        >待推送</span>
        <span
          v-if="status == 2"
          class="status"
        >待确认</span>
        <span
          v-if="status == 3"
          class="status"
        >已发送患者</span>
        <span
          v-if="status == 4"
          class="status"
        >已驳回</span>
      </span>
      <span>
        <el-button
          type="primary"
          style="width: 92px"
          size="medium"
          @click="elitDesc"
          v-if="status == 4"
        >修改</el-button>
        <el-button
          type="primary"
          style="width: 92px"
          size="medium"
          @click="submit"
          v-if="status == 1"
        >保存</el-button>

        <el-button
          plain
          style="width: 92px"
          size="medium"
          @click="back"
        >返回</el-button>
      </span>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div style="font-weight: 700">
          {{ status == 1 ? '摘要编辑' : '摘要' }}
        </div>
        <div v-if="status == 1">
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 10, maxRows: 13}"
              placeholder="请输入内容"
              v-model="info.content_desc"
            >
            </el-input>
          </div>
        </div>
        <div
          style="margin: 20px 0"
          v-else
        >
          {{info.content_desc}}
        </div>
        <div v-if="status == 3">
          <img
            :src="info.doctor_sign_str"
            alt=""
            style="width: 200px"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wangeditor from '../wangeditor.vue';
export default {
  data() {
    return {
      status: this.$route.query.status,
      consult_inquiry_id: this.$route.query.consult_inquiry_id,
      info: {}
    };
  },
  components: {
    wangeditor
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },

  methods: {
    //获取详情
    getDetail() {
      let consult_inquiry_id = this.consult_inquiry_id;
      this.axios
        .post('platform/Inquirysheet/getConsultInquiryContentInfo', {
          consult_inquiry_id
        })
        .then((res) => {
          if (res.code == 0) {
            this.info = res.data.info;
            // if (this.info.content_desc && this.status == 1) {
            //   this.setDesc(this.info.content_desc);
            // }
          }
        });
    },
    // //往编辑器里插入数据
    // setDesc(text) {
    //   this.$refs.editorBox.editor.txt.html(text);
    // },
    //保存
    submit() {
      // let content_desc = this.$refs.editorBox.editor.txt.html();
      if (!this.info.content_desc) {
        this.$message.error('请填写内容');
        return false;
      }
      let data = {
        consult_inquiry_id: this.consult_inquiry_id,
        content_desc: this.info.content_desc
      };
      this.axios
        .post('platform/Inquirysheet/updateContentDesc', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.back();
          }
        });
    },
    //修改
    elitDesc() {
      this.status = 1;
      // setTimeout(() => {
      //   this.setDesc(this.info.content_desc);
      // }, 100);
    },
    //返回
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.status {
  font-size: 14px;
  margin-left: 10px;
}
</style>